export type BrawlOptions<A = unknown, B = A> = {
  teamA: A[]
  teamB: B[]
  fight: (a: A, b: B, indexOf: { a: number; b: number }) => boolean
}

export const brawl = <A = unknown, B = A>({
  teamA,
  teamB,
  fight,
}: BrawlOptions<A, B>): boolean => {
  let idxA = -1
  let idxB = -1
  for (const a of teamA) {
    ++idxA
    for (const b of teamB) {
      ++idxB
      const result = fight(a, b, { a: idxA, b: idxB })
      if (result === true) {
        return true
      }
    }
  }

  return false
}
